export const tableRowHeight = 47;
export const tableHeaderVPadding = 16;
export const tableHeaderHPadding = 16;

export const tableHeaderVPaddingMobile = 16;
export const tableHeaderHPaddingMobile = 16;
